// extracted by mini-css-extract-plugin
export default {"control":"control_control__ec63s","button":"control_button__LDS1u"};